import useAxiosInterceptor from 'src/services/interceptor';
import { patientApiPaths } from '../constants';

class PatientScreeningService {

  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getScreening = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/screening-all`,
      {
        params: payload?.params,
      }
    );
  };

  getSingleScreening = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/${payload.screeningId}`
    );
  };

  createScreening = (payload: any) => {
    return this.axiosInstance.post(
      `${patientApiPaths.createPatient}/${payload?.patientId}${payload.patientId}`
    );
  };

  editScreening = (payload: any) => {
    return this.axiosInstance.post(
      `${patientApiPaths.createPatient}/${payload?.patientId}${payload.patientId}`
    );
  };

  getScreeningType = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/screening-type`
    );
  };

  getDisciplineType = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/discipline-type`
    );
  };

  getAddScreeningGetFormId = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getFormIdOfScreening}/${payload?.patientId}/screening-details/get-screening-template`
    );
  };

  postScreeningSubmission = (payload: any) => {
    const { patientId, ...restPayload } = payload;
    return this.axiosInstance.put(
      `/provider/patient/${payload?.patientId}/screening-details/save-screening-submission`,
      null,
      {
        params: restPayload,
      }
    );
  };
}

const patientScreeningService = new PatientScreeningService();

Object.freeze(patientScreeningService);

export default patientScreeningService;
